<div [bfx-input]="bfxInput" [ngClass]="inputDirective.classes" #input>
  <div class="bfx-input-label">
    <ng-container
      [ngTemplateOutlet]="inputStartContainer"
      [ngTemplateOutletContext]="{'$implicit': chkBoxLabel}"
    ></ng-container>
    <div [ngClass]="inputDirective.labelClasses" #chkBoxLabel>
      {{label}}<span *ngIf="required">*</span>
    </div>
    <ng-container
      [ngTemplateOutlet]="inputEndContainer"
      [ngTemplateOutletContext]="{'$implicit': chkBoxLabel}"
    ></ng-container>
  </div>
  <div [ngClass]="inputDirective.innerClasses">
    <div
      [bfx-field-select]="bfxFieldSelect"
      [ngClass]="fieldDirective.classes"
      [style.display]="hideField ? 'none' : 'flex'"
      #panelParent
    >
      <ng-container *ngFor="let icon of startIconsClasses; index as i">
        <bfx-icon-button
          #ddBtn
          [iconClass]="icon"
          [disabled]="disabled"
          *ngIf="dropdown"
          tabindex="-1"
          (pointerover)="onFieldPointerOver($event)"
          (pointerout)="onFieldPointerOut($event)"
          (action)="onFieldIconClick($event, 'start', i)"
        ></bfx-icon-button>
      </ng-container>
      <ng-container *ngTemplateOutlet="fieldStartContainer"></ng-container>
      <input
        *ngIf="!multiple"
        [ngClass]="fieldDirective.inputClasses"
        [attr.type]="type"
        #in
        type="search"
        autocomplete="off"
        [attr.required]="required"
        [value]="inputFieldValue"
        (click)="onInputClick($event)"
        (input)="onInput($event)"
        (keydown)="onKeydown($event)"
        (keyup)="onKeyup($event)"
        (focus)="onInputFocus($event)"
        (blur)="onInputBlur($event)"
        [attr.disabled]="disabled ? '' : null"
        [attr.placeholder]="placeholder"
        [attr.maxlength]="maxlength"
        [attr.tabindex]="tabindex"
        [readonly]="readonly"
        (pointerover)="onFieldPointerOver($event)"
        (pointerout)="onFieldPointerOut($event)"
      />
      <span *ngIf="fieldSuffix" class="bfx-field-suffix" [innerHtml]="fieldSuffix"></span>
      <ng-container *ngFor="let icon of endIconsClasses; index as i">
        <bfx-icon-button
          #ddBtn
          [parentSize]="size"
          [iconClass]="icon"
          [disabled]="disabled"
          *ngIf="dropdown"
          tabindex="-1"
          (pointerover)="onFieldPointerOver($event)"
          (pointerout)="onFieldPointerOut($event)"
          (action)="onFieldIconClick($event, 'end', i)"
        >
        </bfx-icon-button>
      </ng-container>
      <div
        #panel
        [ngClass]="dropdownMenuClasses"
        [style.width]="appendTo ? 'auto' : '100%'"
        (pointerover)="onListPointerOver($event)"
        (pointerout)="onListPointerOut($event)"
      >
        <div class="bfx-dropdown-header-container"></div>
        <ul
          *ngIf="panelVisible"
          [style.max-height]="scrollHeight"
          [ngClass]="{
            'bfx-dropdown-item-container': true
          }"
        >
          @for (option of suggestions; track $index; let idx = $index) {
          <li
            [ngClass]="{
            'bfx-dropdown-multi-select-item-container-outer': multiple,
            'bfx-dropdown-single-select-item-container-outer': !multiple,
            'bfx-dropdown-single-select-item': !multiple,
            'bfx-dropdown-single-select-item-selected-disabled': !multiple && disabled && selectedIndex == idx,
            'bfx-dropdown-single-select-item-selected-enabled': !multiple && selectedIndex == idx,
            'bfx-dropdown-single-select-item-disabled': !multiple && disabled,
            'bfx-dropdown-single-select-item-hover': !multiple && highlightOption==option,
            'bfx-dropdown-item-disabled': disabled,
            'bfx-dropdown-item-enabled': !disabled,
            'bfx-dropdown-item-selected': selectedIndex == idx,
            'bfx-dropdown-item-hover': highlightOption==option,
          }"
            [attr.title]="tooltipOnItem ? field ? option[field] : option : null"
            (mouseenter)="highlightOption=option"
            (mouseleave)="highlightOption=null"
            (click)="selectItem(option, true)"
          >
            <div
              [class]="multiple ? 'bfx-dropdown-multi-select-item-container-inner' : 'bfx-dropdown-single-select-item-container-inner'"
            >
              <div
                [ngClass]="{
                }"
              >
                {{field ? option[field] : option}}
              </div>
            </div>
          </li>
          <!-- Add a separator for last favourite-->
          <hr *ngIf="option.lastFavorite === true && !$last" class="bfx-dropdown-separator" />
          }
        </ul>

        <div class="comp-dropdown-footer-container">
          <ng-container *ngIf="noResults && emptyMessage">
            <ng-template>{{emptyMessage}}</ng-template>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <!-- </span> -->
  <!-- <span class="p-autocomplete-float-highlight"></span> -->
  <!-- <div
    *ngIf="label!=null"
    [ngClass]="{'ui-label-disabled': disabled}"
    class="p-autocomplete-float-label"
  >
    {{label}}
  </div> -->
</div>
